<div class="card-deck">
  <div
    [ngClass]="{ active: item.id === activeCard }"
    class="card p-3 custom-border-bottom unread"
    (click)="onGiftClick(item?.id)"
  >
    <div class="row">
      <div class="col-3">
        <img
          [src]="item?.files?.[0]?.filePath"
          class="w-80"
          alt="Card image cappppp"
        />
      </div>
      <div class="col-9">
        <div class="">
          <h6 class="card-title fs-14" style="font-weight: 900; color: black">
            {{ lang == "en" ? item?.nameEn : item?.nameAr }}
          </h6>
          <div class="row">
            <div class="col-6 d-flex justify-content-start align-items-center">
              <img src="assets/img/Star.svg" />

              <p class="gray-73 mr-2 ml-2 fs-14" style="font-weight: 400">
                {{ item?.requiredPoints }}
              </p>
            </div>
            <div class="col-6">
              <p style="color: #176ae5" class="fs-12">
                {{
                  lang == "en" ? item?.giftType?.nameEn : item?.giftType?.nameAr
                }}
              </p>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6 d-flex justify-content-start align-items-center">
              <img src="assets/img/box.svg" />

              <p class="gray-73 mr-2 ml-2 fs-14" style="font-weight: 400">
                {{ item?.initialStock }}
              </p>
            </div>
            <div class="col-6 d-flex justify-content-start align-items-center">
              <img src="assets/img/ava.svg" />

              <p
                class="gray-73 mr-2 ml-2 fs-14"
                style="font-weight: 400"
                [translatable]="{
                  transKey: 'loyalty.ava',
                  modEnum: translationModulesEnum.loyalty
                }"
              >
                {{ "loyalty.ava" | translate }} {{ item?.actualStock }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
